// Create or update your Testimonials.js component

import React, { useState, useEffect } from 'react';
import './Testimonials.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faQuoteLeft, faChevronLeft, faChevronRight, faStar } from '@fortawesome/free-solid-svg-icons';

const Testimonials = () => {
  const [testimonialsData, setTestimonialsData] = useState([]);
  const [currentIndex, setCurrentIndex] = useState(0);
  const [activeSlide, setActiveSlide] = useState(null);
  const [animating, setAnimating] = useState(false);
  const [autoplay, setAutoplay] = useState(true);

  // Fetch reviews from backend
  useEffect(() => {
    fetch('/api/reviews')
      .then(res => res.json())
      .then(data => {
        setTestimonialsData(data);
        if (data.length) {
          setActiveSlide(data[0]);
        }
      })
      .catch(err => console.error('Failed to load reviews', err));
  }, []);

  
  // Function to render star ratings
  const renderStars = (rating) => {
    return (
      <div className="testimonial-stars">
        {[...Array(5)].map((_, i) => (
          <FontAwesomeIcon 
            key={i} 
            icon={faStar} 
            className={i < Math.floor(rating) ? 'star-filled' : 'star-empty'} 
          />
        ))}
      </div>
    );
  };
  
  // Navigate to previous slide
  const prevSlide = () => {
    if (animating) return;
    
    setAnimating(true);
    const newIndex = currentIndex === 0 ? testimonialsData.length - 1 : currentIndex - 1;
    setCurrentIndex(newIndex);
    setActiveSlide(testimonialsData[newIndex]);
    
    // Reset autoplay timer
    setAutoplay(false);
    setTimeout(() => setAutoplay(true), 100);
    
    // Reset animation flag
    setTimeout(() => setAnimating(false), 600);
  };
  
  // Navigate to next slide
  const nextSlide = () => {
    if (animating) return;
    
    setAnimating(true);
    const newIndex = currentIndex === testimonialsData.length - 1 ? 0 : currentIndex + 1;
    setCurrentIndex(newIndex);
    setActiveSlide(testimonialsData[newIndex]);
    
    // Reset autoplay timer
    setAutoplay(false);
    setTimeout(() => setAutoplay(true), 100);
    
    // Reset animation flag
    setTimeout(() => setAnimating(false), 600);
  };
  
  // Set direct navigation
  const goToSlide = (index) => {
    if (animating || index === currentIndex) return;
    
    setAnimating(true);
    setCurrentIndex(index);
    setActiveSlide(testimonialsData[index]);
    
    // Reset autoplay timer
    setAutoplay(false);
    setTimeout(() => setAutoplay(true), 100);
    
    // Reset animation flag
    setTimeout(() => setAnimating(false), 600);
  };
  
  // Autoplay functionality - INCREASED to 8 seconds (8000ms)

  useEffect(() => {
    if (!autoplay || testimonialsData.length === 0) {
      return;
    }

    const interval = setInterval(() => {
      nextSlide();
    }, 8000); // Increased from default 3-5 seconds to 8 seconds

    return () => clearInterval(interval);
  }, [currentIndex, autoplay, testimonialsData.length]);

  if (!activeSlide) {
    return null;
  }
  
  return (
    <section className="testimonials-section">
      <div className="container">
        <div className="section-header">
          <h2 className="section-title">What Our Customers Say</h2>
          <p className="section-description">
            Don't just take our word for it - see what our satisfied customers have to say about our roofing services.
          </p>
        </div>
        
        <div className="testimonials-slider">
          <div className="testimonial-card">
            <div className="quote-icon">
              <FontAwesomeIcon icon={faQuoteLeft} />
            </div>
            
            <div className="testimonial-content">
              <p className="testimonial-text">{activeSlide.text}</p>
              
              <div className="testimonial-author">
                <div className="author-info">
                  <h4 className="author-name">{activeSlide.name}</h4>
                  <p className="author-location">{activeSlide.location}</p>
                </div>
                {renderStars(activeSlide.rating)}
              </div>
            </div>
          </div>
          
          <div className="testimonial-controls">
            <button className="control-btn prev" onClick={prevSlide} aria-label="Previous testimonial">
              <FontAwesomeIcon icon={faChevronLeft} />
            </button>
            
            <div className="testimonial-dots">
              {testimonialsData.map((_, index) => (
                <button 
                  key={index} 
                  className={`dot ${index === currentIndex ? 'active' : ''}`}
                  onClick={() => goToSlide(index)}
                  aria-label={`Go to testimonial ${index + 1}`}
                />
              ))}
            </div>
            
            <button className="control-btn next" onClick={nextSlide} aria-label="Next testimonial">
              <FontAwesomeIcon icon={faChevronRight} />
            </button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Testimonials;